import { useTranslation } from "@lib/useTypedTranslation";
import { IProps, RemoveFilterButton } from ".";
import { get, isEmpty, map } from "lodash";
import { ButtonColours } from "../../../../containers/app/themes";

export const LegacyFilterStatus = (props: IProps) => {
  const { t } = useTranslation('translation');

  const filterBoxes = map(props.selectedFilters, (filter) => {
    let removeButton;
    if (props.onFilterRemoved) {
      removeButton = <RemoveFilterButton
        ariaLabel={`remove ${filter.id} filter button`}
        dataId={`${filter.id}-filter_close_button`}
        colour={ButtonColours.grey}
        iconStyle={'fas fa-times'}
        onClick={() => props.onFilterRemoved(filter.id, filter)}
      ></RemoveFilterButton>;
    }
    const filterClass = get(props.filterClasses, `${filter.group}.${filter.id}`, '');
    return (
      <div key={`filter_box_${filter.id}`} data-cy={`filter-id--${filter.id}`} className={`filter-box ${filterClass}`}>
        {removeButton}
        <span className={props.onNavigateFilters ? "navigate" : ""} onClick={() => { props.onNavigateFilters && props.onNavigateFilters(filter.id, filter); }}>{filter.display}</span>
      </div>
    );
  });

  const clearButton = props.onClearFilters && <span className="navigate clear" onClick={props.onClearFilters}>{t('CLEAR_ALL')}</span>;
  const editButton = props.onEditFilters && <span className="navigate edit" onClick={props.onEditFilters}>{t('EDIT_FILTERS')}</span>;
  const controlsSection = !isEmpty(props.selectedFilters) && (
    <div className="filter-controls">
      {editButton}
      {clearButton}
    </div>
  );

  return (
    <div className='filter-status-block'>
      <div className="filter-row">
        {filterBoxes}
        {controlsSection}
      </div>
    </div>
  );
};
